module.exports = __webpack_public_path__ + "img/cfd6a55.svg";